import { InvalidConfigurationError } from "builder-util"
import { log } from "builder-util/out/log"
import debug from "debug"
import { realpath } from "fs/promises"
import * as path from "path"
import * as requireMaybe from "../../helpers/dynamic-import"

export async function resolveModule<T>(type: string | undefined, name: string): Promise<T> {
  try {
    return requireMaybe.dynamicImportMaybe(name)
  } catch (error: any) {
    log.error({ moduleName: name, message: error.message ?? error.stack }, "Unable to dynamically `import` or `require`")
    throw error
  }
}

export async function resolveFunction<T>(type: string | undefined, executor: T | string, name: string, rootSearchDir: string): Promise<T> {
  if (executor == null || typeof executor !== "string") {
    // is already function or explicitly ignored by user
    return executor
  }

  let p = executor as string
  if (p.startsWith(".")) {
    p = path.resolve(p)
    let realP = p
    let realRoot = rootSearchDir
    try {
      realP = await realpath(p)
      realRoot = await realpath(rootSearchDir)
    } catch {
      // path may not exist yet; fall back to lexical check
    }
    const relative = path.relative(realRoot, realP)
    if (relative.startsWith("..") || path.isAbsolute(relative)) {
      throw new InvalidConfigurationError(`Hook module path "${executor}" resolves outside the workspace root ("${rootSearchDir}")`)
    }
  }

  try {
    p = require.resolve(p)
  } catch (e: any) {
    debug(e)
    p = path.resolve(p)
  }

  const m: any = await resolveModule(type, p)
  const namedExport = m[name]
  if (namedExport == null) {
    return m.default || m
  } else {
    return namedExport
  }
}
